import styled from 'styled-components';
import { getToken } from '@optimus-web/common';

export interface ListDividerProps {
    hidden?: boolean;
}

const ListDivider = styled.hr`
    margin: 0;
    height: 0;
    border: none;
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};

    ${(props) => props.hidden && 'display: none;'}
`;

export default ListDivider;
